module.exports = __webpack_public_path__ + "media/images/prandi-hover-ead8c3e10e21866a9b8130dfa7e9f1c9.jpg";